<template>
  <div class="modal fade" :id="idModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Registro de {{ typePerson==='T' ? 'Tripulantes': 'Pasajeros' }} </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="form-row">
                            <div class="form-group col-12 col-md-5">
                                <label for="name_tripulant" class="badge badge-primary">Nombre(s) y Apellidos</label>
                                <input type="text" class="form-control" v-model="new_tripulant.name_comp" name="name_complete" placeholder="Nombre" autocomplete="off">
                            </div>
                            <div class="form-group col-12 col-md-3">
                                <label for="number_identification" class="badge badge-primary">Numero de Identificacion</label>
                                <input type="number" class="form-control" name="identification" placeholder="4766xxx" autocomplete="off" v-model="new_tripulant.document">
                            </div>
                            <div class="form-group col-12 col-md-2">
                                <label for="genre_aux" class="badge badge-primary">Genero</label>
                                <select name="" id="" class="form-control" v-model="aux_genre">
                                    <option v-for="aux_gen in genre" :key="aux_gen.id" :value="aux_gen">{{ aux_gen.value }}</option>
                                </select>
                            </div>
                            <div class="form-group col-12 col-md-2">
                                <label for="years" class="badge badge-primary">Edad</label>
                                <input type="number" class="form-control" name="flag" placeholder="30" autocomplete="off" v-model="new_tripulant.age">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-3" v-if="typePerson==='T'">
                                <label for="book_emb" class="badge badge-primary" >Libreta Embarco</label>
                                <input type="text" class="form-control" name="book_emb" placeholder="12355487" autocomplete="off" v-model="new_tripulant.book_emb">
                            </div>
                            <div class="form-group col-12 col-md-3">
                                <label for="phone" class="badge badge-primary">Telefono</label>
                                <input type="text" class="form-control" name="flag" placeholder="72548744" autocomplete="off" v-model="new_tripulant.phone">
                            </div>
                            <div class="form-group col-12 col-md-3" v-if="typePerson==='T'">
                                <label for="t_person" class="badge badge-primary">Cargo</label>
                                <input type="text" class="form-control" name="flag" placeholder="Capitan" autocomplete="off" v-model="new_tripulant.rol">
                            </div>
                            <div class="form-group col-12 col-md-3">
                                <label for="nationality" class="badge badge-primary">Nacionalidad</label>
                                <select name="" id="" class="form-control" v-model="aux_nationality">
                                    <option v-for="aux_is in nationality" :key="aux_is.id" :value="aux_is">{{ aux_is.detail }}</option>
                                </select>
                            </div>
                        </div>
                        <br>
                        <button class="btn btn-success col-12 col-md-4 offset-md-4" @click="mSavePerson"><font-awesome-icon icon="save" size="lg" /> Registrar</button>
                        <div class="table-responsive" v-if="cPersonList.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre Completo</th>
                                        <th>Nacionalidad</th>
                                        <th>Genero</th>
                                        <th>Telefono</th>
                                        <th>Rol</th>
                                        <th>---</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(lp, index) in cPersonList" :key="lp.document" >
                                        <td v-if="lp.type === typePerson">{{ index+1 }}</td>
                                        <td v-if="lp.type === typePerson">{{ lp.name_comp }}</td>
                                        <td v-if="lp.type === typePerson">{{ lp.nationality_description }}</td>
                                        <td v-if="lp.type === typePerson">{{ lp.genre_description }}</td>
                                        <td v-if="lp.type === typePerson">{{ lp.phone }}</td>
                                        <td v-if="lp.type === typePerson">{{ lp.rol }}</td>
                                        <td v-if="lp.type === typePerson"><button class="btn btn-danger" @click="mDeletePerson(lp.document)"><font-awesome-icon icon="minus-circle" size="lg" /></button></td>
                                    </tr>
                                </tbody>
                            </table>                            
                        </div>

                    </div>               
                    
                    <div class="modal-footer">
                        
                        <button type="button" class="btn btn-outline-danger" data-dismiss="modal"><font-awesome-icon icon="times-circle" size="lg" /></button>
                        
                    </div>
                </div>
            </div>
            
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';

export default {
    name:'modal-add-person',
    mounted(){
        this.mCallOptions();
    },
    props:{
        idModal:String,
        typePerson:{
            type:String,
            default:'P'
        }

    },
    data(){
        return{
            nationality:[],
            genre:[{id:'M', value:'MUJER'}, {id:'V', value:'VARON' }],
            // issued:[],
            new_tripulant:{
                name_comp:null,
                phone:0,
                age:0,
                document:null,
                nationality:0,
                nationality_description:null,
                genre:null,
                genre_description:null,
                rol:null,
                book_emb:null
            },
            list_person:[],
            aux_genre:{id:0, value:null},
            aux_nationality:{id:0, value:null}
        }
    },
    methods:{
        async mCallOptions(){

            let nation=await axios.get(`globals/country?api_token=${Vue.auth.getToken()}`);
            // let aux_issued=await axios.get(`globals/citys?api_token=${Vue.auth.getToken()}`);
            
            // this.issued=aux_issued.data;
            this.nationality=nation.data;
        },
        mValidateForm(){
            
            if( this.new_tripulant.name_comp===null || this.new_tripulant.name_comp.length < 2){
                toastr.warning('Indique el nombre de la persona ', 'Advertencia');
                return false;
            }
            if( this.new_tripulant.document===null || this.new_tripulant.document.length < 2){
                toastr.warning('Indique el Numero de identificacion', 'Advertencia');
                return false;
            }

            // if( this.new_tripulant.phone <= 0 ){
            //     toastr.warning('Indique un telefono de referencia', 'Advertencia');
            //     return false;
            // }

            if(this.typePerson==='T'){
                if( this.new_tripulant.rol === null ){
                    toastr.warning('Indique el Rol del Tripulante', 'Advertencia');
                    return false;
                }    
            }

            if( this.aux_genre.id === 0 ){
                toastr.warning('Seleccione un Genero', 'Advertencia');
                return false;
            }

            if( this.aux_nationality.id === 0 ){
                toastr.warning('Seleccione una Nacionalidad', 'Advertencia');
                return false;
            }
            return true;
        },
        mResetForm(){            
                this.new_tripulant.name_comp=null;
                this.new_tripulant.document=null;
                this.new_tripulant.phone=0;
                this.new_tripulant.nationality=0;
                this.new_tripulant.age=0;
                this.new_tripulant.rol=null;
                this.new_tripulant.book_emb=null;                
        },
        mSavePerson(){
            if(this.mValidateForm()){
                // console.log(this.new_tripulant);
                let aux_pers={
                    document:this.new_tripulant.document,
                    name_comp:this.new_tripulant.name_comp,
                    genre:this.aux_genre.id,
                    genre_description:this.aux_genre.value,
                    nationality:this.aux_nationality.id,
                    nationality_description:this.aux_nationality.detail,
                    rol:this.typePerson==='T' ? this.new_tripulant.rol:'PASAJERO',
                    age:this.new_tripulant.age,
                    phone:this.new_tripulant.phone,
                    type:this.typePerson,
                    book_emb:this.new_tripulant.book_emb
                }
                this.$store.dispatch('sListPersonDispatch/addPersonList', aux_pers);
                this.mResetForm(); 
            }
        },
        mDeletePerson(doc){
            this.$store.dispatch('sListPersonDispatch/deletePerson', doc);
        }
    },
    filters:{
        upper:function(value){
            return value.toUpperCase();
        }
    },
    computed:{
        cPersonList(){
            
            // retornamos las cargas registradas
            return this.$store.getters['sListPersonDispatch/getListPersons'];
            // return this.$store.getters.getChargeSec
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/cotizacion/modalAppendPerson.vue